/*
 * Initialize
 */

const initializeCart = () => {
  initializeItemControls();
  initializeBottomBar();
  updateCart();
};

const initializeItemControls = () => {
  const itemEls = document.querySelectorAll(".cart-form-item");
  itemEls.forEach((itemEl) => {
    const select = itemEl.querySelector(".fs-select-variants");
    if (select) {
      select.addEventListener("change", variantChanged);
    }
    itemEl.querySelectorAll('.fs-quantity-minus-button[data-quantity-type="variant"]').forEach((button) => {
      button.addEventListener("click", minusButtonClicked);
    });
    itemEl.querySelectorAll('.fs-quantity-plus-button[data-quantity-type="variant"]').forEach((button) => {
      button.addEventListener("click", plusButtonClicked);
    });
    itemEl.querySelectorAll(".fs-wrapping-checkbox").forEach((checkbox) => {
      checkbox.addEventListener("change", wrappingCheckboxChanged);
    });
    itemEl.querySelectorAll('.fs-quantity-minus-button[data-quantity-type="wrapping"]').forEach((button) => {
      button.addEventListener("click", wrappingMinusButtonClicked);
    });
    itemEl.querySelectorAll('.fs-quantity-plus-button[data-quantity-type="wrapping"]').forEach((button) => {
      button.addEventListener("click", wrappingPlusButtonClicked);
    });
    const wrappingPopup = itemEl.querySelector(".fs-wrapping-popup-button");
    if (wrappingPopup) {
      const wp = itemEl.querySelector(".fs-wrapping-popup-dialog");
      wrappingPopup.addEventListener("click", () => showWrappingPopup(wp));
    }
    itemEl.querySelectorAll(".fs-remove-button").forEach((button) => {
      button.addEventListener("click", removeButtonClicked);
    });
  });
};

const initializeBottomBar = () => {
  const subtotalDiv = document.querySelector("#fs-subtotal");
  const footer = document.querySelector("#shopify-section-footer");
  const bottomBar = document.querySelector("#fs-cart-bottom-bar");

  const updateBottomBar = () => {
    const subtotalDivRect = subtotalDiv.getBoundingClientRect();
    const footerRect = footer.getBoundingClientRect();
    const bottomBarRect = bottomBar.getBoundingClientRect();
    if (window.innerWidth < 1000) {
      bottomBar.classList.toggle("show", window.innerHeight < footerRect.top);
    } else {
      bottomBar.classList.toggle("show", subtotalDivRect.bottom < 0 && window.innerHeight < footerRect.top);
    }
  };

  if (subtotalDiv) {
    window.addEventListener("load", updateBottomBar);
    window.addEventListener("scroll", updateBottomBar);
  }
};

/*
 *  Update
 */

const updateCart = async () => {
  showBackdrop();
  const cart = await fetch("/cart.js").then((response) => response.json());
  if (cart.items.length <= 0) {
    document.querySelector(".cart-form-content .fs-empty").classList.add("cart-empty");
    document.querySelector(".cart-form-content .fs-form").classList.add("cart-empty");
    hideBackdrop();
    return;
  }
  cart.items.forEach((item) => {
    renderItem(item, cart);
  });
  const removed = await removeUnusedWrappingItem(cart);
  if (removed) {
    updateCart();
    return;
  }
  updateTotalPrice(cart);
  hideBackdrop();
};

/*
 *  Render items
 */

const renderItem = (item, cart) => {
  if (item.product_type == "OPTION") {
    return;
  }
  const itemEl = document.querySelector(`.cart-form-item[data-variant-id="${item.variant_id}"]`);
  renderItemInner(item, itemEl);
  const wrappingItems = renderItemWrapping(item, cart, itemEl);
  renderItemPrice(item, wrappingItems, itemEl);
};

const renderItemInner = (item, itemEl) => {
  const select = itemEl.querySelector(".fs-select-variants");
  if (select) {
    select.dataset.lineItemKey = item.key;
    select.dataset.currentVariantId = item.variant_id;
    select.dataset.quantity = item.quantity;
  }
  const textInput = itemEl.querySelector('.fs-input-quantity[data-quantity-type="variant"]');
  textInput.value = item.quantity;
  textInput.dataset.variantId = item.variant_id;
  textInput.dataset.lineItemKey = item.key;

  const minusButton = itemEl.querySelector('.fs-quantity-minus-button[data-quantity-type="variant"]');
  minusButton.dataset.variantId = item.variant_id;
  const plusButton = itemEl.querySelector('.fs-quantity-plus-button[data-quantity-type="variant"]');
  plusButton.dataset.variantId = item.variant_id;
  plusButton.disabled = textInput.max <= item.quantity;
  const removeButton = itemEl.querySelector(".fs-remove-button");
  removeButton.dataset.variantId = item.variant_id;
  removeButton.dataset.lineItemKey = item.key;
};

const renderItemWrapping = (item, cart, itemEl) => {
  itemEl.querySelectorAll(".fs-wrapping-checkbox").forEach((checkbox) => {
    checkbox.dataset.variantId = item.variant_id;
  });
  itemEl.querySelectorAll(".fs-input-quantity").forEach((quantityInput) => {
    quantityInput.dataset.variantId = item.variant_id;
  });
  const wrappingItems = cart.items.filter(
    (wItem) => wItem.product_type == "OPTION" && wItem.properties.variantId == item.variant_id,
  );
  if (wrappingItems.length <= 0) {
    itemEl.querySelectorAll(".fs-wrapping-checkbox").forEach((checkbox) => {
      checkbox.dataset.wrappingLineItemKey = null;
      checkbox.checked = false;
    });
    itemEl.querySelectorAll('.fs-input-quantity[data-quantity-type="wrapping"]').forEach((quantityInput) => {
      quantityInput.value = 0;
      quantityInput.max = 0;
    });
    return [];
  }
  wrappingItems.forEach((wrappingItem) => {
    const checkbox = itemEl.querySelector(
      `.fs-wrapping-checkbox[data-wrapping-variant-id="${wrappingItem.variant_id}"]`,
    );
    checkbox.dataset.wrappingLineItemKey = wrappingItem.key;
    checkbox.checked = true;
    const quantityInput = itemEl.querySelector(
      `.fs-input-quantity[data-quantity-type="wrapping"][data-wrapping-variant-id="${wrappingItem.variant_id}"]`,
    );
    quantityInput.dataset.wrappingLineItemKey = wrappingItem.key;
    quantityInput.value = wrappingItem.quantity;
    quantityInput.max = item.quantity;
    const minusButton = itemEl.querySelector(
      `.fs-quantity-minus-button[data-quantity-type="wrapping"][data-wrapping-variant-id="${wrappingItem.variant_id}"]`,
    );
    minusButton.dataset.variantId = item.variant_id;
    const plusButton = itemEl.querySelector(
      `.fs-quantity-plus-button[data-quantity-type="wrapping"][data-wrapping-variant-id="${wrappingItem.variant_id}"]`,
    );
    plusButton.dataset.variantId = item.variant_id;
    plusButton.disabled = quantityInput.max <= wrappingItem.quantity;
  });
  return wrappingItems;
};

const renderItemPrice = (item, wrappingItems, itemEl) => {
  if (0 < item.discounts.length) {
    const discounts = [];
    const lines = item.discounts.map((discount) => {
      const originalLinePrice = new Intl.NumberFormat("ja-JP").format(item.original_line_price / 100);
      const title = discount.title.toUpperCase();
      const text = `${title} (<s>&yen; ${originalLinePrice}</s>)`;
      return text;
    });
    const contents = `<p class="fs-discounts-content">${lines.join("<br>")}</p>`;
    itemEl.querySelector(".fs-discounts").innerHTML = contents;
  }

  const wrappingPrice = wrappingItems.reduce((s, item) => s + item.line_price, 0);
  const price = item.line_price + wrappingPrice;
  itemEl.querySelector(".fs-amount").innerHTML =
    `&yen; ${new Intl.NumberFormat("ja-JP").format(price / 100)} <span>税込</span>`;
};

/*
 *  removeUnusedWrappingItem
 */

const removeUnusedWrappingItem = async (cart) => {
  const removeItems = cart.items
    .map((item) => {
      if (item.product_type != "OPTION") {
        return null;
      }
      const targetVariantId = item.properties.variantId;
      if (!targetVariantId) {
        return { key: item.key, quantity: 0 };
      }
      const targetItem = cart.items.find((targetItem) => targetItem.variant_id == targetVariantId);
      if (!targetItem) {
        return { key: item.key, quantity: 0 };
      }
      if (targetItem.quantity < item.quantity) {
        return { key: item.key, quantity: targetItem.quantity };
      }
      return null;
    })
    .filter((item) => item != null);

  if (!removeItems || removeItems.length <= 0) {
    return false;
  }
  for (const removeItem of removeItems) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: removeItem.key,
        quantity: removeItem.quantity,
      }),
    });
  }
  return true;
};

/*
 * Variant controls
 */

const variantChanged = async (e) => {
  showBackdrop();
  const cart = await fetch(location.origin + "/cart.js").then((response) => response.json());

  const newVariantId = e.target.value;
  const newVariantTitle = e.target.selectedOptions[0].textContent.trim();
  const currentVariantId = e.target.dataset.currentVariantId;
  const itemEl = document.querySelector(`.cart-form-item[data-variant-id="${currentVariantId}"]`);

  const duplicateItem = cart.items.find((item) => item.variant_id == newVariantId);
  if (duplicateItem) {
    window.alert("同じアイテムをカートに追加済みです。");
    e.target.value = currentVariantId;
    hideBackdrop();
    return;
  }

  const key = e.target.dataset.lineItemKey;
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: key,
      quantity: 0,
    }),
  });

  const quantity = parseInt(e.target.dataset.quantity);
  const newInventoryQuantity = parseInt(e.target.selectedOptions[0].dataset.inventoryQuantity);
  const newQuantity = Math.min(quantity, newInventoryQuantity);
  await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: newVariantId,
      quantity: newQuantity,
    }),
  });

  const wrappingItem = cart.items.find(
    (wItem) => wItem.product_type == "OPTION" && wItem.properties.variantId == currentVariantId,
  );
  if (wrappingItem) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: wrappingItem.key,
        quantity: 0,
      }),
    });
    const newWrappingQuantity = Math.min(wrappingItem.quantity, newQuantity);
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: wrappingItem.variant_id,
        quantity: newWrappingQuantity,
        properties: {
          variantId: newVariantId,
          productTitle: itemEl.dataset.productTitle,
          variantTitle: newVariantTitle,
        },
      }),
    });
  }

  itemEl.dataset.variantId = newVariantId;
  itemEl.dataset.variantTitle = newVariantTitle;

  const newImage = e.target.selectedOptions[0].dataset.variantImage;
  const imageEl = itemEl.querySelector(`.fs-detail-image .fs-image img`);
  imageEl.src = newImage;

  e.target.currentVariantId = newVariantId;

  const textInput = itemEl.querySelector('.fs-input-quantity[data-quantity-type="variant"]');
  textInput.max = newInventoryQuantity;

  updateCart();
};

const minusButtonClicked = (e) => {
  const variantId = e.currentTarget.dataset.variantId;
  const itemEl = document.querySelector(`.cart-form-item[data-variant-id="${variantId}"]`);
  const quantityInput = itemEl.querySelector('.fs-input-quantity[data-quantity-type="variant"]');
  const newQuantity = parseInt(quantityInput.value) - 1;
  quantityInput.value = Math.max(0, Math.min(quantityInput.max, newQuantity));
  const plusButton = itemEl.querySelector('.fs-quantity-plus-button[data-quantity-type="variant"]');
  plusButton.disabled = quantityInput.max <= newQuantity;
  quantityInputChanged(`${variantId}-quantity}`, variantId);
};

const plusButtonClicked = (e) => {
  const variantId = e.currentTarget.dataset.variantId;
  const itemEl = document.querySelector(`.cart-form-item[data-variant-id="${variantId}"]`);
  const quantityInput = itemEl.querySelector('.fs-input-quantity[data-quantity-type="variant"]');
  const newQuantity = parseInt(quantityInput.value) + 1;
  quantityInput.value = Math.max(0, Math.min(quantityInput.max, newQuantity));
  e.currentTarget.disabled = quantityInput.max <= newQuantity;
  quantityInputChanged(`${variantId}-quantity}`, variantId);
};

const quantityInputChanged = debounceByKey(async (variantId) => {
  showBackdrop();
  const itemEl = document.querySelector(`.cart-form-item[data-variant-id="${variantId}"]`);
  const quantityInput = itemEl.querySelector('.fs-input-quantity[data-quantity-type="variant"]');
  const key = quantityInput.dataset.lineItemKey;
  const quantity = parseInt(quantityInput.value);
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: key,
      quantity: quantity,
    }),
  });
  if (quantity <= 0) {
    itemEl.remove();
  }
  updateCart();
}, 800);

/*
 *  wrapping controls
 */

const wrappingCheckboxChanged = async (e) => {
  showBackdrop();
  if (e.target.checked) {
    const variantId = e.target.dataset.variantId;
    const wrappingVariantId = e.target.dataset.wrappingVariantId;
    const itemEl = document.querySelector(`.cart-form-item[data-variant-id="${variantId}"]`);
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: wrappingVariantId,
        quantity: 1,
        properties: {
          variantId: variantId,
          productTitle: itemEl.dataset.productTitle,
          variantTitle: itemEl.dataset.variantTitle,
        },
      }),
    });
    updateCart();
  } else {
    const key = e.target.dataset.wrappingLineItemKey;
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: key,
        quantity: 0,
      }),
    });
    updateCart();
  }
};

const wrappingMinusButtonClicked = (e) => {
  const variantId = e.currentTarget.dataset.variantId;
  const wrappingVariantId = e.currentTarget.dataset.wrappingVariantId;
  const itemEl = document.querySelector(`.cart-form-item[data-variant-id="${variantId}"]`);
  const quantityInput = itemEl.querySelector(
    `.fs-input-quantity[data-quantity-type="wrapping"][data-wrapping-variant-id="${wrappingVariantId}"]`,
  );
  const newQuantity = parseInt(quantityInput.value) - 1;
  quantityInput.value = Math.max(0, Math.min(quantityInput.max, newQuantity));
  const plusButton = itemEl.querySelector(
    `.fs-quantity-plus-button[data-quantity-type="wrapping"][data-wrapping-variant-id="${wrappingVariantId}"]`,
  );
  plusButton.disabled = quantityInput.max <= newQuantity;
  wrappingQuantityInputChanged(`${variantId}-${wrappingVariantId}-quantity-wrapping}`, variantId, wrappingVariantId);
};

const wrappingPlusButtonClicked = (e) => {
  const variantId = e.currentTarget.dataset.variantId;
  const wrappingVariantId = e.currentTarget.dataset.wrappingVariantId;
  const itemEl = document.querySelector(`.cart-form-item[data-variant-id="${variantId}"]`);
  const quantityInput = itemEl.querySelector(
    `.fs-input-quantity[data-quantity-type="wrapping"][data-wrapping-variant-id="${wrappingVariantId}"]`,
  );
  const newQuantity = parseInt(quantityInput.value) + 1;
  quantityInput.value = Math.max(0, Math.min(quantityInput.max, newQuantity));
  e.currentTarget.disabled = quantityInput.max <= newQuantity;
  wrappingQuantityInputChanged(`${variantId}-${wrappingVariantId}-quantity-wrapping}`, variantId, wrappingVariantId);
};

const wrappingQuantityInputChanged = debounceByKey(async (variantId, wrappingVariantId) => {
  showBackdrop();
  const itemEl = document.querySelector(`.cart-form-item[data-variant-id="${variantId}"]`);
  const quantityInput = itemEl.querySelector(
    `.fs-input-quantity[data-quantity-type="wrapping"][data-wrapping-variant-id="${wrappingVariantId}"]`,
  );
  const key = quantityInput.dataset.wrappingLineItemKey;
  const quantity = parseInt(quantityInput.value);
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: key,
      quantity: quantity,
    }),
  });
  if (quantity <= 0) {
    const checkbox = itemEl.querySelector(`.fs-wrapping-checkbox[data-wrapping-variant-id="${wrappingVariantId}"]`);
    checkbox.checked = false;
  }
  updateCart();
}, 800);

const showWrappingPopup = (wrappingPopup) => {
  const popup = wrappingPopup;
  popup.classList.add("show");
  const backdrop = popup.querySelector(".fs-popup-backdrop");
  const closeButton = popup.querySelector(".fs-close-button");
  backdrop.addEventListener("click", () => {
    popup.classList.remove("show");
    backdrop.removeEventListener("click");
    closeButton.removeEventListener("click");
  });
  closeButton.addEventListener("click", () => {
    popup.classList.remove("show");
    backdrop.removeEventListener("click");
    closeButton.removeEventListener("click");
  });
};

/*
 * Total Price
 */

const updateTotalPrice = (cart) => {
  const total = `&yen; ${new Intl.NumberFormat("ja-JP").format(cart.total_price / 100)} <span>税込</span>`;
  document.querySelector("#fs-subtotal p").innerHTML = total;
  document.querySelector(`#fs-cart-bottom-bar .fs-subtotal p`).innerHTML = total;
};

/*
 *  Bottom buttons
 */

const removeButtonClicked = async (e) => {
  showBackdrop();
  const key = e.target.dataset.lineItemKey;
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: key,
      quantity: 0,
    }),
  });
  const variantId = e.target.dataset.variantId;
  const itemEl = document.querySelector(`.cart-form-item[data-variant-id="${variantId}"]`);
  itemEl.remove();
  updateCart();
};

/*
 * Backdrop
 */

const showBackdrop = () => {
  document.querySelector(".cart-backdrop").classList.add("show");
};

const hideBackdrop = () => {
  document.querySelector(".cart-backdrop").classList.remove("show");
};

function debounceByKey(fn, delay) {
  const timers = new Map(); // key -> timer
  return function (key, ...args) {
    clearTimeout(timers.get(key));
    const t = setTimeout(() => {
      timers.delete(key);
      fn(...args);
    }, delay);
    timers.set(key, t);
  };
}

function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer); // 前の予約をキャンセル
    timer = setTimeout(() => {
      fn.apply(this, args); // delay後に1回だけ実行
    }, delay);
  };
}

/*
 * Main
 */

const cartMain = () => {
  if (!location.pathname.startsWith("/cart")) {
    return;
  }
  initializeCart();
};

addEventListener("DOMContentLoaded", (event) => {
  cartMain();
});
